import apiClient from '../client'

export const notificationService = {
  // List notifications for the authenticated account (paginated, newest first)
  getNotifications: async (params = {}) => {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    if (params.page) query.append('page', params.page)
    if (params.limit) query.append('limit', params.limit)

    const queryString = query.toString()
    const url = queryString ? `/notifications?${queryString}` : '/notifications'
    const response = await apiClient.get(url)
    return response.data
  },

  // Lightweight unread badge count
  getUnreadCount: async () => {
    const response = await apiClient.get('/notifications/unread-count')
    return response.data
  },

  markAsRead: async (id) => {
    const response = await apiClient.patch(`/notifications/${id}/read`)
    return response.data
  },

  markAsUnread: async (id) => {
    const response = await apiClient.patch(`/notifications/${id}/unread`)
    return response.data
  },

  markAllAsRead: async () => {
    const response = await apiClient.patch('/notifications/read-all')
    return response.data
  },

  deleteNotification: async (id) => {
    const response = await apiClient.delete(`/notifications/${id}`)
    return response.data
  },

  deleteAllRead: async () => {
    const response = await apiClient.delete('/notifications/read')
    return response.data
  },
}
